export class OAuthConfigurationHubEvents {
    public static UpdateErrorMessage = "UpdateErrorMessage";
    public static ClearErrorMessage = "ClearErrorMessage";
}

export class NavigationConstants {
    public static OAuthConfigurationListView = "OAuthConfigurations";
    public static OAuthConfigurationView = "OAuthConfiguration";
}

export class StoreKeys {
    public static OAuthConfigurationList = "OAUTH_CONFIGURATION_LIST_STORE_KEY";
    public static OAuthConfiguration = "OAUTH_CONFIGURATION_STORE_KEY";
}

export class ActionCreatorKeys {
    public static OAuthConfigurationList = "OAUTH_CONFIGURATION_LIST_ACTION_CREATOR_KEY";
    public static OAuthConfiguration = "OAUTH_CONFIGURATION_ACTION_CREATOR_KEY";
}

export class ActionKeys {
    public static OAuthConfigurationList = "OAUTH_CONFIGURATION_LIST_ACTIONS_KEY";
    public static OAuthConfiguration = "OAUTH_CONFIGURATION_ACTIONS_KEY";
}

export class HelpLinks {
    public static OAuthConfigurationLearnMoreLink = "https://docs.microsoft.com/en-us/azure/devops/pipelines/library/service-endpoints?view=vsts#sep-githubent";
}